import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/build/css/mdb.css';
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import 'fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import firebase from 'firebase';
import { rtdbPlugin } from 'vuefire'
// import '@babel/polyfill'
// require('babel-polyfill');
Vue.use(rtdbPlugin)

Vue.config.productionTip = false;

// const config = {
// 	apiKey: "AIzaSyCzBSrGvrupGEcVj6nM_uwa2kDtDxWMjbw",
// 	authDomain: "oawebsite-b391e.firebaseapp.com",
// 	databaseURL: "https://oawebsite-b391e.firebaseio.com",
// 	projectId: "oawebsite-b391e",
// 	storageBucket: "oawebsite-b391e.appspot.com",
// 	messagingSenderId: "755248539958",
// // appId: "1:755248539958:web:4174c1647e0f80f697eb97"
// };
//   // Initialize Firebase
// firebase.initializeApp(config);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// firebase.auth().onAuthStateChanged(function(user) {
//   if (!app) {
//     app = new Vue({
//       el: '#app',
//       template: '<App/>',
//       components: { App },
//       router
//     })
//   }
// })